import { render, staticRenderFns } from "./AddProjectSupplierCostModal.vue?vue&type=template&id=f384a9e6&"
import script from "./AddProjectSupplierCostModal.vue?vue&type=script&lang=js&"
export * from "./AddProjectSupplierCostModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports